export class FileUtils {
  /**
   * convert File object to base64
   *
   * @param file the File object
   *
   * @return Promise with base64
   */
  static FileToBase64(file: File): Promise<string> {
    return new Promise((resolve) => {
      const fileReader = new FileReader();
      fileReader.onload = () => resolve(fileReader.result!.toString());
      fileReader.readAsDataURL(file);
    });
  }

  /**
   * checks file extension
   *
   * @param allowedTypes allowed types array
   * @param type the file type
   *
   * @return boolean
   */
  static checkExtension(type: string, allowedTypes: string[]): boolean {
    const extensionName = type.split('/').pop();
    const extension = `.${extensionName}`;
    return allowedTypes.includes(extension);
  }
}
